module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductWarehouseAvailability":{"now":"ihned","availability":"není skladem | skladem {count} ks | skladem {count} ks | skladem > 5 ks","free":"zdarma","footerText":"Pro doručení na prodejnu či vytvoření rezervace je nutné vytvořit objednávku.","heading":"Dostupnost na prodejnách","notAvailable":"není skladem"}}}')
  delete Component.options._Ctor
}
